<template>
  <section :class="style.password">
    <one-line-form :submit="updatePassword" :submittable="isValid" :saving="isSaving ? hiddenPassword : ''">
      <template slot="underlay">
        <transition name="fade-scale">
          <div class="input" v-if="(showRules && rules.length > 0) && !isValid">
            <ins>
              <span>
              {{i18n.t("passwordAnimated:make_it_strong")}}
              </span>
            </ins>
          </div>
        </transition>
      </template>
      <transition name="fade">
        <div class="password">
          <input type="email" autocomplete="email" :value="credentials.email" hidden>
          <input-field :title="i18n.t('passwordAnimated:password')" name="personal-password" type="text" :value="password" class="unmaskPassword" :placeholder="i18n.t('passwordAnimated:placeholder')" @input="syncPassword" :autocorrect="false" :maxlength="partner.passwordRules.maxLength.toString()" :cleanRegExp="new RegExp(/\s+$/)" :pattern="pattern" id="passwordField" :hiddenValue="app.hidePassword"/>
          <div class="button-wrapper" @click="toggle" :class="{disappear: isValid && !app.deviceIsDesktop}">
            <button type="button" class="hideButton" :class="{hiddenPass : app.hidePassword}" :title="hidePassTitle"></button>
          </div>
        </div>
      </transition>
      <helper>
          <a href="#" @click.prevent="toggle" :class="{showHide: isValid && !app.deviceIsDesktop, underline: true}" v-show="isValid && !app.deviceIsDesktop">{{ i18n.t(`passwordAnimated:${app.hidePassword ? 'show' : 'hide'}`) }}</a>
      </helper>
    </one-line-form>
    
     <transition name="fade">
        <helper v-if="isPasswordIncludesEmail()" >
          <p class="showWarning"> {{i18n.t('password:warning_email')}} </p>
        </helper>
      </transition>

      <transition name="fade">
        <helper v-if="(!isPasswordContainValidCharacters() && !isDeFlow) && this.password.length" >
          <p class="showWarning"> {{i18n.t('password:static_hint')}} </p>
        </helper>
      </transition>

      <transition name="fade">
        <helper v-if="password.length < 1 || !password" >
          <p> {{i18n.t('passwordAnimated:password_hint')}} </p>
        </helper>
        <helper v-else-if="password.length < minPasswordLength && !userIsTyping " >
          <p> {{i18n.t('passwordAnimated:minimum_length', {count : minPasswordLength})}} </p>
        </helper>
      </transition>
      
      <helper v-show="password.length >= minPasswordLength && rules.length > 0">
        <span class="password-rules-hint" v-show="showRules && rules.length > 0"> 
            <template> {{i18n.t("passwordAnimated:please_include")}} </template>
        </span>
        <transition-group class="password-rules" name="fade-tags-items" tag="ul">
            <li
            v-show="showRules && rules.length > 0"
            v-for="(rule, index) in rules"
            :key="rule.name + index"
            :class="{ hide: (rule.hide || false), animatedTag: rule.valid() }">
              {{ i18n.t("passwordAnimated:"+rule.name, {'count': rule.value}) }}
            </li>
          </transition-group>
        
      </helper>
    <show-keyboard :focus-element="input"></show-keyboard>
  </section>
</template>

<style lang="scss" rel="stylesheet/scss" scoped>

  .password {
    margin-right: 50px;
  }


   .showWarning {
    color: $inputWarningColor;
    font-size: $inputWarningSize;
    font-weight: $inputWarningWeight;
  }

  .hideButton {
    position: absolute;
    top: 20px;
    right: 10px;
    z-index: 300;
    font-size: .75rem;
    line-height:42px;
    color: #0082FF;
    background: #fff;
    padding: 0 6px;
    width: 60px;
    height: 50px;
    line-height: 50px;
    box-shadow: none;
    border-radius: 0 !important;
    &:before,
    &:after {
      content: '';
      background-repeat: no-repeat;
      background-position: center;
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
    
    // IE11 workaround
    &:after {
      background-image: url('~static/hide.svg');
    }

    &:before {
      background-position: center 8px;
      background-image: url('~static/show.svg');
      opacity: 0;
    }

    &.hiddenPass{
      &:before {
        opacity: 1;
      }

      &:after {
        opacity: 0;
      }
    }
  }

  .button-wrapper {
    position: absolute;
    z-index: 500;
    top: -20px;
    right: -30px;
    height: 90px;
    width: 80px;
  }

  .disappear {
    display: none;
  }


  .password-rules {
      display: flex;
      list-style: none;
      flex-wrap: wrap;
      &-hint {
          display: block;
          margin-bottom: 10px;
          opacity: 0;
          animation: opacity-animation .5s .6s ease-out forwards;
      }
      li {
        font-size: $inputHintSize;
        letter-spacing: 0;
        line-height: 20px;
        text-align: left;
        color: $greyTextColor;
        border: 1px solid $greyTextColor;
        margin-bottom: 5px;
        border-radius: 4px;
        padding: 7.5px 8.5px;
        margin-right: 5px;
        display: flex;
        align-items: center;  
        transition: all .4s linear;  
        transition-property: width,display;
        background: white;
        z-index: 1;

        &:last-of-type {
            margin-right: 0;
        }

        &.hide {
          display: none;
        }
        
        &.animatedTag {
            color: $savingTextColor;
            border-color: $savingTextColor;

            &:before {
                content: "";
                animation-name: rule-checkmark;
                animation-duration: .4s;
                animation-timing-function : ease-out;
                animation-fill-mode: forwards;
                transition: all .2s ease-out;
                border-bottom: solid 1.5px $savingTextColor;
                border-left: solid 1.5px $savingTextColor;
                left: 0;
                height: 4px;
                width: 11px;
                transform: rotate(-90deg);
                opacity: 0;
                margin-right: 5px;
                margin-top: -2px;
            }
         }
      }
  }

  .showHide {
    line-height: 22px;
    opacity: 0;
    animation-name: opacity-animation;
    animation-duration: 0.3s;
    animation-delay: 0.4s;
    animation-fill-mode: forwards;
    animation-timing-function: linear;
  }


  ins {
    color: transparent;
    background: #FFE676;
    display: inline-block;
    position: relative;
    max-width: 100%;
    position: absolute;
    top: 30px;

    span {
      background: no-repeat left 9px;
      background-image: url('~static/warning_pointer.svg');
      position: absolute;
      display: block;
      left: 40px;
      bottom: 100%;
      height: 40px;
      color: $inputWarningColor;
      color: $inputWarningColor-portal;
      font-size: 1rem;
      font-weight: lighter;
      padding-left: 42px;
      margin-bottom: 34px;
      line-height: 120%;
      margin-left: 50px;
    }
  }

  @keyframes rule-checkmark{
    0% {
        width: 0;
        transform: rotate(-90deg);
        opacity: 0;
    }
    50% {
        width: 11px;
        transform: rotsate(-90deg);
         opacity: .3;
    }
    55% {
        transform: rotsate(-90deg);
         opacity: .3;
    }
    100% {
        transform: rotate(-44deg);
        opacity: 1;
    }
  }

  @keyframes opacity-animation {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }



  .fade-scale-enter-active {
    animation: fadeScale .3s forwards;
    animation-timing-function: ease-out;
    transition: all .3s ease-out;
  }

  @keyframes fadeScale {
    0% {
      transform: scale(0);
      opacity: 0;
    }
    90% {
      transform: scale(1.05);
      opacity: 1;
    }
    100% {
      transform: scale(1);
      opacity: 1;
    }
  }

  .fade-tags-items-enter-active {
     animation-name: fadeTags;
     animation-duration: .3s;
     animation-delay: .6s;
     animation-timing-function: ease-out;
     animation-fill-mode: forwards;
     opacity: 0;

     transform: translateY(-15px);
     &:before {
       animation-delay: 2s !important;
     }
  }

   .fade-tags-items-leave-active {
     transition: none;
     animation: none !important;
     opacity: 0;
   }

  @keyframes fadeTags {
    0% {
      opacity: 0;
      transform: translateY(-30px);
      transition: all .3s ease-out;
    }
    90% {
      opacity:0.6;
      transform: translateY(-10px);
      transition: all .3s ease-out;
    }
    100% {
      opacity:1;
      transform: translateY(0);
      transition: all .3s ease-out;
    }
  }

</style>

<script>
  import Vue from 'vue'
  import { mapState, mapGetters } from 'vuex'

  import { setSelection } from '../utils/selection'
  import fieldCustomRules from '../mixins/customFieldsRules'
  import Breakpoints from '../mixins/breakpoints'
  import CharKeyboard from '../components/CharKeyboard'
  import AdditionalKeyboard from '../components/AdditionalKeyboard'

  export default Vue.component('credentials-animated-password-screen', {
    
    components: {
      'char-keyboard': CharKeyboard,
      'additional-keyboard': AdditionalKeyboard
    },
    props: ['screenParams'],
    mixins: [
      Breakpoints,
      fieldCustomRules
    ],
    data () {
      const credentials = this.$store.state.credentials
      const customFieldRuless = this.getFieldCustomRules("password")
      const minPasswordLength = (customFieldRuless && customFieldRuless.minLength) || this.$store.state.partner.passwordRules.minLength

      return {
        oldPassword: credentials.password,
        password: credentials.password,
        isSaving: false,
        readOnly: true,
        fromPasswordWarning: this.$store.state.route.from.fullPath.includes('password-warning'),
        rules: [],
        minPasswordLength,
        showRules: false,
        showRuleTimeout: null,
        userIsTyping: false,
        userIsTypingTimeout: null
      }
    },
    watch: {
      password (val) {
          this.userIsTyping = true
          this.togglePasswordRules()

          clearTimeout(this.showRuleTimeout)
          if (val && val.length >= this.minPasswordLength && !this.showRules) {
            this.showRuleTimeout = setTimeout(() => {
                if (!this.isValid) {
                    this.showRules = true
                }
            }, 1000)
          } else if (!val || val.length < this.minPasswordLength) {
             this.showRules = false
             clearTimeout(this.userIsTypingTimeout)
             this.userIsTypingTimeout = setTimeout(() => {
                this.userIsTyping = false
             }, 1000)
          }
      },
      showRules (val) {
          if (val) {
            this.calculateRuleTagsWidth()
          }
      },
      isValid () {
        this.$emit('tooltip', this.isValid ? ['enter'] : ['type'])
      },
      isSaving () {
        if (this.isSaving) {
          this.$emit('tooltip', 'hide')
        }
      }
    },
    mounted () {
      const hide = this.partner.hidePasswordByDefault
      const desktop = this.app.deviceIsDesktop

      if (hide.length) {
        this.$store.dispatch('updateApp', {
          hidePassword: (desktop && hide.indexOf('desktop') >= 0) || (!desktop && hide.indexOf('mobile') >= 0)
        })
      }

      this.focus(this.app.hidePassword)
      this.rules = this.getPasswordRules()

      this.$emit('tooltip', ['type'])
    },
    computed: {
      style(){
        return {
          password: this.$css(`
            .password-rules {
              li {
                font-size: ${this.theme.inputHintSize} !important;
                color: ${this.theme.greyTextColor} !important;
                border: 1px solid ${this.theme.greyTextColor} !important;
                &.animatedTag {
                    color: ${this.theme.savingTextColor} !important;
                    border-color: ${this.theme.savingTextColor} !important;
                    &:before {
                        border-bottom: solid 1.5px ${this.theme.savingTextColor} !important;
                        border-left: solid 1.5px ${this.theme.savingTextColor} !important;
                    }
                }
              }
            } 
            
            .showWarning {
              color: ${this.theme.inputWarningColor} !important;
              font-size: ${this.theme.inputWarningSize} !important;
              font-weight: ${this.theme.inputWarningWeight} !important;
            }

            ins {
              span {
                color: ${this.theme.inputWarningColor} !important;
              }
            }
          `)
        }
      },
      ...mapState(['credentials', 'app', 'user', 'emailValidation', 'route', 'partner']),
      ...mapGetters(['isDeFlow']),
      pattern () {
        const customFieldRuless = this.getFieldCustomRules("password")
        return '_'.repeat((customFieldRuless && customFieldRuless.maxLength) || this.partner.passwordRules.maxLength)
      },
      hiddenPassword () {
        return this.password.replace(/./g, '•')
      },
      hidePassTitle () {
        if (this.app.hidePassword) {
          return this.i18n.t('passwordAnimated:show')
        }
        return this.i18n.t('passwordAnimated:hide')
      },
      isValid () {
        if (this.fromPasswordWarning && this.password === this.oldPassword) {
          return false
        }

        if (this.isFlexibleValidation) {
          return this.isPasswordMinimumCriteriaMatched && this.minLengthTest() && !this.isPasswordIncludesEmail()
        }
  
        return this.lettersTest() && this.lowercaseLetterTest() && this.uppercaseLetterTest() && this.digitsTest() && this.specialsTest() && this.digitsOrSpecials() && this.minLengthTest() && (this.isPasswordContainValidCharacters() || this.isDeFlow)
      },
      isFlexibleValidation () {
        return this.partner.passwordRules.customConfig && this.partner.passwordRules.customConfig.mode === 'flexible'
      },
      isPasswordMinimumCriteriaMatched () {
        const matchingCriteria = this.partner.passwordRules.customConfig.criteria.reduce((acum, rule) => {
          if (this.flexibleModeRulePassed(rule)) {
            return acum + 1
          }
          return acum
        }, 0)

        return matchingCriteria >= this.partner.passwordRules.customConfig.minimumMatchingCriteria
      }
    },
    methods: {
       calculateRuleTagsWidth () {
        // Calculate width for rule tags, to make sure it doesn't break to the next line when a new rule requirement is fit
        this.$nextTick(() => {
            let calcWidth = 0
            const passwordRulecontainer = document.querySelector('.password-rules')
            const ruleTags = document.querySelectorAll('.password-rules li')

            Array.from(ruleTags).forEach((currentItem, index) => {
                currentItem.style.removeProperty('margin-right')
                calcWidth += currentItem.offsetWidth + (currentItem.classList.contains('animatedTag') ? 0 : 40)
                if (passwordRulecontainer && calcWidth >= passwordRulecontainer.offsetWidth) {
                   calcWidth = 0

                   const breakTag = document.createElement('div')
                   breakTag.setAttribute('style', 'flex-basis:100%;height:0')
                   passwordRulecontainer.insertBefore(breakTag, currentItem)
                }
            })
        }, 10)
      },
      isPasswordContainValidCharacters () {
        const allowedCharactersReg = this.partner.passwordRules.allowedCharactersReg
        return allowedCharactersReg ? allowedCharactersReg.test(this.password) : true
      },
      isPasswordIncludesEmail () {
        if (this.isFlexibleValidation && this.partner.passwordRules.customConfig.validateEmail) {
          const email = this.credentials.email
          const emailFirstPart = email.substring(0, email.lastIndexOf('@'))
  
          return (new RegExp(email)).test(this.password) || (new RegExp(emailFirstPart)).test(this.password)
        }
      },
      flexibleModeRulePassed (rule) {
        if (
          (rule === 'lowercase' && this.lowercaseLetterTest()) ||
          (rule === 'uppercase' && this.uppercaseLetterTest()) ||
          (rule === 'digit' && this.digitsTest()) ||
          (rule === 'special' && this.specialsTest())
        ) {
          return true
        }

        return false
      },
      flexibleModeHasRule (rule) {
        if ((this.isFlexibleValidation && this.partner.passwordRules.customConfig.criteria.includes(rule))) {
          return true
        }

        return false
      },
  
      input () {
        if (!this.$el) return {}
        return this.$el.querySelector('#passwordField input')
      },

      syncPassword (value) {
        this.password = value
      },

      updatePassword () {
        if (this.password) {
          this.isSaving = true
          this.readOnly = true
          this.$store.dispatch('updateCredentials', {
            password: this.password
          })

           if (this.fromPasswordWarning) {
            return this.$store.dispatch('replace', this.route.from.fullPath)
          }

          this.$store.dispatch('next', this.screenParams.nextScreenRoute)
        }
      },

      toggle () {
        this.$store.dispatch('updateApp', {
          hidePassword: !this.app.hidePassword
        })
        this.$nextTick(() => this.focus(this.app.hidePassword))
      },

      focus () {
        let input = this.$el.querySelector('#passwordField input')
        const length = this.password.length

        if (input) {
          this.readOnly = false
          this.$nextTick(() => setSelection(input, { start: length, end: length }))
        }
      },
      minLengthTest () {
        const customFieldRuless = this.getFieldCustomRules("password")
        const minPasswordLength = (customFieldRuless && customFieldRuless.minLength) || this.partner.passwordRules.minLength

        return this.password.trim().length >= minPasswordLength
      },
      lettersTest () {
        if (this.isDeFlow) {
          return /[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(this.password) && this.lowercaseLetterTest() && this.uppercaseLetterTest()
        }
        return this.partner.passwordRules.letters ? /[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(this.password) && this.lowercaseLetterTest() && this.uppercaseLetterTest() : true
      },
      hasLetter () {
        return /[a-zA-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞßàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(this.password)
      },
      uppercaseLetterTest () {
        if (this.isDeFlow) {
          return /[A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞß]/.test(this.password)
        }
        return (this.partner.passwordRules.letterCasing || this.flexibleModeHasRule('uppercase')) ? /[A-ZÀÁÂÃÄÅÆÇÈÉÊËÌÍÎÏÐÑÒÓÔÕÖØÙÚÛÜÝÞß]/.test(this.password) : true
      },
      lowercaseLetterTest () {
        if (this.isDeFlow) {
          return /[a-zàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(this.password)
        }
        return (this.partner.passwordRules.letterCasing || this.flexibleModeHasRule('lowercase')) ? /[a-zàáâãäåæçèéêëìíîïðñòóôõöøùúûüýþÿ]/.test(this.password) : true
      },
      digitsTest () {
        if (this.isDeFlow) {
          return /[\d]/.test(this.password)
        }
        return (this.partner.passwordRules.digits || this.flexibleModeHasRule('digit')) ? /[\d]/.test(this.password) : true
      },
      digitsTestIfDigitsOrSpecials () {
        return this.partner.passwordRules.digits || this.partner.passwordRules.digitsOrSpecials ? /[\d]/.test(this.password) : true
      },
      specialsTest () {
        if (this.isDeFlow) {
          return /[ \\!\x22#\\$%&\x27/^+?@_;‰@#$%^&*()_+\-=~`[\]{};:',.?|"<>]/.test(this.password)
        }
        return (this.partner.passwordRules.specials || this.flexibleModeHasRule('special')) ? /[ \\!\x22#\\$%&\x27//^+?@_;‰@#$%^&*()_+-=~`[\]{};',./?|"<>]/.test(this.password) : true
      },
      specialsTestIfDigitsOrSpecials () {
        return this.partner.passwordRules.specials || this.partner.passwordRules.digitsOrSpecials ? /[ \\!\x22#\\$%&\x27\\(\\)\\*\\+,\-\\.\\/\\:;\\<\\=\\>\\?@\\[\\\]\\^_`\\{\\|\\}~]/.test(this.password) : true
      },
      digitsOrSpecials () {
        return this.partner.passwordRules.digitsOrSpecials ? /[\d]/.test(this.password) || /[ \\!\x22#\\$%&\x27\\(\\)\\*\\+,\-\\.\\/\\:;\\<\\=\\>\\?@\\[\\\]\\^_`\\{\\|\\}~]/.test(this.password) : true
      },
      getPasswordRules () {
        let rules = []
        let passwordRules = this.$store.state.partner.passwordRules

        if (passwordRules.letterCasing || this.isDeFlow) {
          rules.push({name: 'uppercase_letter', valid: this.uppercaseLetterTest})
          rules.push({name: 'lowercase_letter', valid: this.lowercaseLetterTest})
        } else {
          if (passwordRules.letters) rules.push({name: 'letter', valid: this.lettersTest})
        }
        if (passwordRules.digits || this.isDeFlow) rules.push({name: 'digit', valid: this.digitsTest})
        if (passwordRules.specials || this.isDeFlow) rules.push({name: 'special', valid: this.specialsTest})
        if (passwordRules.digitsOrSpecials || this.isDeFlow) {
          rules.push({name: 'digit', valid: this.digitsTestIfDigitsOrSpecials})
          rules.push({name: 'special', valid: this.specialsTestIfDigitsOrSpecials})
        }
        return rules
      },
      togglePasswordRules () {
         this.rules.forEach((rule) => {
            if (!this.showRules && rule.valid()) {
              rule.hide = true
            } else if (rule.hide && !rule.valid()) {
              rule.hide = false
            }
          })
      }
    }
  })
</script>


// WEBPACK FOOTER //
// src/screens/PersonalPassword.vue